import { useState, useEffect } from "react";
import { GetAxios } from "../helpers/axiosHelpers";

/**
 * Hook to fetch content blocks from the backend
 * @param {string} sectionId - UUID

 of the section (optional)
 * @param {string} slug - Slug of the section (optional)
 * @param {string} blockType - Type of blocks to filter (optional)
 * @returns {{ blocks: Array, loaded: boolean }}
 */
export const useContentBlocks = (sectionId, slug, blockType) => {
  const [blocks, setBlocks] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams();
    if (sectionId) params.append('sectionId', sectionId);
    if (slug) params.append('slug', slug);
    if (blockType) params.append('blockType', blockType);

    const queryString = params.toString();
    const endpoint = queryString
      ? `/content-blocks/public?${queryString}`
      : '/content-blocks/public';

    GetAxios(endpoint)
      .then((res) => {
        if (res?.success && Array.isArray(res.data)) {
          setBlocks(res.data);
        }
      })
      .catch(() => {
        // Fail silently, component will use fallback
      })
      .finally(() => setLoaded(true));
  }, [sectionId, slug, blockType]);

  return { blocks, loaded };
};
